import React, {useState} from 'react';
import { Routes, Route } from 'react-router-dom';
import ReadAndSelect from './ReadAndSelect/ReadAndSelect';
import ReadAndComplete from './ReadAndComplete/ReadAndComplete';
import { Navigate } from 'react-router-dom';
import Layout from './Layout';
import Login from './Account/Login';
import ListenAndType from './ListenAndType/ListenAndType';
import ReadAloud from './ReadAloud/ReadAloud';
import InteractiveReading from './InteractiveReading/InteractiveReading';
import GenericTask from './Shared/GenericTask';
import InteractiveListening from './InteractiveListening/InteractiveListening';
import BuySubscription from './Account/BuySubscription';
const  App  = (props)=> {
  
  let localToken = localStorage.getItem('access_token');
  
        
  if (localToken===null || localToken.length===0){
    localToken=null 
  }

  const [token,setToken] = useState(localToken)
  

  

  function onLogin(token){
    setToken(token)
  }


  function onLogout(token){
    console.log('onLogout');
    localStorage.removeItem('access_token');
    setToken(null)
  }

   return <div className="">
    
            <Routes>
              <Route index element={<Navigate to="/home" replace />}/>
              <Route path=":affiliateId" element={<Layout onLogout={onLogout} token={token}/>}>
                <Route index element={<Login token={token} onLogin={onLogin}/>} ></Route>
                <Route   path="readandselect" element={<ReadAndSelect onLogout={onLogout} token={token} />} ></Route>
                <Route   path="readandcomplete" element={<ReadAndComplete  onLogout={onLogout} token={token} />} ></Route>
                <Route   path="listenandtype" element={<ListenAndType  onLogout={onLogout} token={token} />} ></Route>
                <Route   path="readaloud" element={<ReadAloud  onLogout={onLogout} token={token} />} ></Route>
                <Route   path="interactivereading" element={<InteractiveReading  onLogout={onLogout} token={token} />} ></Route>
                {['readthenwrite','readthenspeak','listenthenspeak','writeaboutphoto','speakaboutphoto'].map(path=><Route key={'route-'+path} path={path} element={<GenericTask appName={path} onLogout={onLogout} token={token} />}></Route>)}
                <Route   path="interactivelistening" element={<InteractiveListening  onLogout={onLogout} token={token} />} ></Route>
                <Route   path="buysubscription" element={<BuySubscription  onLogout={onLogout} token={token} />} ></Route>
              </Route>
              
            </Routes>
        </div>
  }


export default App;